import { z } from 'zod'

export const sendTipsFormSchema = z.object({
  amount: z.coerce
    .number({
      required_error: 'Please enter a valid amount',
      invalid_type_error: 'Please enter a valid amount',
    })
    .min(0.01, { message: 'Amount must be greater than $0' })
    .max(250, { message: 'Amount cannot be greater than $250' })
    .step(0.01, { message: 'Amount must be in increments of $0.01' }),
  workId: z.coerce
    .number({ required_error: 'Shift is required' })
    .gt(0, { message: 'Please select a valid shift' }),
})
